import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { LayoutService } from "./shared/services/layout.service";
import { NgxColorsModule } from "ngx-colors";
import { ColorPickerModule } from "ngx-color-picker";
import { NgxEditorModule } from "ngx-editor";
// UPGRADE NOTE: NgxEchartsModule.forRoot() moved here from components.module.ts,
// dashboard.module.ts, and charts.module.ts, which each independently called it too.
// .forRoot() is meant to be called exactly once, at the true application root - calling it
// repeatedly across multiple lazy-loaded modules (that don't even share a common lazy-loaded
// ancestor) is unreliable, since the module is a shared singleton config. Providing it once here,
// in the eagerly-loaded root module, makes the NGX_ECHARTS_CONFIG available to every descendant
// injector app-wide, including all lazy-loaded feature modules - each of those now just imports
// the bare NgxEchartsModule (no forRoot/forChild call needed).
import { NgxEchartsModule } from "ngx-echarts";

// UPGRADE NOTE (Angular 15 -> 21): @angular/fire v6 only supported the legacy "namespaced" Firebase
// JS SDK (v8) and doesn't work with modern Angular. @angular/fire v7+ split into a modern "modular"
// API and a "compat" API that preserves the exact same AngularFireModule/AngularFireAuthModule/etc.
// classes and method signatures we already use below. We deliberately import from the `/compat`
// entry points so none of the calling code (this file, messaging.service.ts, login-page.component.ts)
// needs to change - only these import paths do.
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireDatabaseModule, AngularFireList, AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { environment } from "src/environments/environment";

/////service===
import { InterceptorService } from "./services/interceptor.service";
import { AsyncPipe, DatePipe } from "@angular/common";
import { DataSharingService } from "./services/data.share.service";
import { MessagingService } from './services/messaging.service';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    // UPGRADE NOTE (ngx-toastr 15 -> 19): `ToastContainerModule` was removed from ngx-toastr's
    // public API - newer versions handle the toast container automatically as part of
    // `ToastrModule` itself, so a separate module/component is no longer needed. It was never
    // used as a template element anywhere in this app (confirmed via search), so removing the
    // import and this registration is a safe, zero-behavior-change fix.
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireDatabaseModule,
    NgxColorsModule,
    ColorPickerModule,
    NgxEditorModule,
    NgxEchartsModule.forRoot({
      echarts: () => import("echarts"),
    })], providers: [
      MessagingService,
      AsyncPipe,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: InterceptorService,
        multi: true,
      },
      DataSharingService,
      DatePipe,
      provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class AppModule { }
